import { AbstractService } from "./abstract-service";
import { URLS } from "./app-urls";

export interface Holiday {
    id: number;
    date: string;
    description: string;
    country: "BRASIL" | "CHINA";
    scope?: "national" | "MANAUS" | "SAO_PAULO" | null;
    holiday_type?: "feriado" | "tiaoxiu" | null;
    source: "seed" | "import" | "api" | "manual";
    active: boolean;
}

export interface HolidayRangePayload {
    description: string;
    country: "BRASIL" | "CHINA";
    scope?: "national" | "MANAUS" | "SAO_PAULO";
    holiday_type?: "feriado" | "tiaoxiu";
    start_date: string;
    end_date?: string;
}

export class NpiHolidayService extends AbstractService<Holiday> {
    constructor() {
        super(URLS.HOLIDAY);
    }
}